import React, { useState } from "react";
import {
	Container,
	Box,
	Typography,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	CircularProgress,
	Snackbar,
	Alert,
} from "@mui/material";
import logout from "../../assets/logout.jpg";

const LogoutPage = () => {
	const [openConfirm, setOpenConfirm] = useState(false);
	const [loading, setLoading] = useState(false);
	const [snackbar, setSnackbar] = useState({
		open: false,
		message: "",
		severity: "success",
	});

	// Open confirmation dialog
	const handleOpenConfirm = () => {
		setOpenConfirm(true);
	};

	// Close confirmation dialog
	const handleCloseConfirm = () => {
		setOpenConfirm(false);
	};

	// Handle logout with mock API call
	const handleLogout = () => {
		setOpenConfirm(false);
		setLoading(true);

		// Simulate API call with success or error response randomly
		fakeApiCall()
			.then(() => {
				setLoading(false);
				setSnackbar({
					open: true,
					message: "Logout successful!",
					severity: "success",
				});
				// Redirect after short delay to show notification
				setTimeout(() => {
					window.location.href = "/DTCL-secured-with-key-admin-login";
				}, 1500);
			})
			.catch(() => {
				setLoading(false);
				setSnackbar({
					open: true,
					message: "Logout failed. Please try again.",
					severity: "error",
				});
			});
	};

	// Mock API function
	const fakeApiCall = () =>
		new Promise((resolve, reject) => {
			const success = Math.random() > 0.3; // 70% chance of success
			setTimeout(() => {
				success ? resolve() : reject();
			}, 2000);
		});

	// Handle snackbar close
	const handleCloseSnackbar = () => {
		setSnackbar({ ...snackbar, open: false });
	};

	return (
		<Container
			maxWidth="md"
			sx={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				bgcolor: "#f0f4f8",
				padding: 4,
				position: "relative",
			}}>
			{/* Loading overlay */}
			{loading && (
				<Box
					sx={{
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
						bgcolor: "rgba(255,255,255,0.7)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 999,
					}}
					aria-busy="true"
					aria-hidden={!loading}>
					<CircularProgress size={60} />
				</Box>
			)}

			{/* Main content box */}
			<Box
				sx={{
					width: "100%",
					maxWidth: 500,
					bgcolor: "white",
					borderRadius: 3,
					boxShadow: 4,
					padding: 4,
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
				}}
				role="region"
				aria-labelledby="logout-title">
				{/* Logo */}
				<Box
					component="img"
					src={logout} // Replace with your logo path
					alt="Courier Admin Logo"
					sx={{
						width: 100,
						height: 100,
						mb: 2,
						borderRadius: "50%",
						objectFit: "contain",
						boxShadow: 1,
					}}
				/>

				{/* Heading */}
				<Typography
					id="logout-title"
					variant="h4"
					component="h1"
					gutterBottom
					sx={{ textAlign: "center" }}>
					Logout Admin Now
				</Typography>

				{/* Success Message */}
				<Typography
					variant="h6"
					color="textSecondary"
					gutterBottom
					sx={{ textAlign: "center" }}>
					{/* You have successfully logged out */}
				</Typography>

				{/* Additional Info */}
				<Typography
					variant="body1"
					color="textSecondary"
					sx={{ mt: 2, mb: 4, textAlign: "center" }}>
					{/* Please log in again to access your dashboard and manage deliveries
					effectively. */}
				</Typography>

				{/* Logout Button */}
				<Button
					variant="contained"
					color="primary"
					size="large"
					sx={{ width: "100%", mb: 2 }}
					onClick={handleOpenConfirm}
					aria-haspopup="dialog"
					aria-controls="logout-confirmation">
					Logout
				</Button>

				{/* Return Home Button */}
				{/* <Button
					variant="text"
					color="secondary"
					onClick={() => (window.location.href = "/")}
					sx={{ width: "100%" }}>
					Return to Home
				</Button> */}
			</Box>

			{/* Confirmation Dialog */}
			<Dialog
				open={openConfirm}
				onClose={handleCloseConfirm}
				aria-labelledby="confirmation-dialog-title"
				aria-describedby="confirmation-dialog-description">
				<DialogTitle id="confirmation-dialog-title">Are you sure?</DialogTitle>
				<DialogContent>
					<Typography id="confirmation-dialog-description">
						Do you really want to log out? This action cannot be undone.
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseConfirm} color="secondary" autoFocus>
						Cancel
					</Button>
					<Button
						onClick={handleLogout}
						variant="contained"
						color="primary"
						autoFocus>
						Yes, Logout
					</Button>
				</DialogActions>
			</Dialog>

			{/* Snackbar for notifications */}
			<Snackbar
				open={snackbar.open}
				autoHideDuration={3000}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
				<Alert
					onClose={handleCloseSnackbar}
					severity={snackbar.severity}
					sx={{ width: "100%" }}>
					{snackbar.message}
				</Alert>
			</Snackbar>
		</Container>
	);
};

export default LogoutPage;
